module.exports = __webpack_public_path__ + "static/media/image-768.071448e1.jpg";